export default __webpack_public_path__ + "static/media/sub-compomentd.6a9dbe4c.svg";